/**
 * SET-141: the blackout sub-screen's Remove action.
 *
 * Production deletes through a GET link. The endpoint behind this refuses anything that is not a
 * post and scopes the row on the session's agent, so the control has to be a button that posts -
 * which is what Adzuki.MySettings.ListActions (SET-133) does, along with the three server answers
 * and the reload that follows.
 */

(function MySettingsBlackout($, Adzuki)
{
	"use strict";

	// INSIDE ready, NOT AT LOAD - gulp concatenates js/Adzuki/*.js by filename, so this file runs
	// before my_settings_list_actions.js and the helper does not exist yet at load time.
	$(document).ready(function documentReady() {
		if (!Adzuki.MySettings || !Adzuki.MySettings.ListActions) {
			return;
		}

		Adzuki.MySettings.ListActions.bind({
			url    : '/MySettings/livePlanner',
			actions: [
				{
					event   : 'click',
					selector: '[data-my-settings-blackout-delete]',
					url     : function remove($control) {
						return '/MySettings/livePlannerBlackoutDelete/' + $control.attr('data-my-settings-blackout-delete');
					},
					failure: 'There was an error attempting to remove the blackout date.'
				}
			]
		});
	});
}(jQuery, window.Adzuki || {}));
